var map = {
	"./mark-1.png": 81373,
	"./mark-2.png": 63929,
	"./mark-3.png": 49528,
	"./mark-4.png": 38599,
	"./mark-5.png": 16449,
	"./mark-6.png": 75121,
	"./mark-7.png": 83373,
	"./mark-8.png": 11299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48064;